import classNames from 'classnames'
import { get, toNumber } from 'lodash/fp'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import { Icon } from '@masterplandev/ui'

import styles from './Notification.module.css'

export const NOTIFICATION_SUCCESS = 'success'
export const NOTIFICATION_WARN = 'warn'
export const NOTIFICATION_ERROR = 'error'

export default class Notification extends Component {
  ref = React.createRef()

  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    inner: PropTypes.bool,
    adjustWrapper: PropTypes.bool,
    fixed: PropTypes.bool,
    timeout: PropTypes.number,
    type: PropTypes.oneOf([
      NOTIFICATION_SUCCESS,
      NOTIFICATION_ERROR,
      NOTIFICATION_WARN,
    ]),
  }

  static defaultProps = {
    className: null,
    children: null,
    type: null,
    inner: false,
    fixed: false,
    timeout: 0,
    adjustWrapper: true,
  }

  rootDOM: any

  timer: any

  constructor(props) {
    super(props)
    this.timer = null
    this.state = { height: 0, show: true }
  }

  componentDidMount() {
    // @ts-expect-error TS(2339): Property 'timeout' does not exist on type 'Readonl... Remove this comment to see the full error message
    const { timeout } = this.props
    this.rootDOM = document.getElementById('root')
    window.addEventListener('resize', this.updateHeight)
    this.updateHeight()
    if (timeout > 0) {
      this.timer = setTimeout(() => {
        this.setState({ show: false, height: 0 })
      }, timeout)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // @ts-expect-error TS(2339): Property 'height' does not exist on type 'Readonly... Remove this comment to see the full error message
    this.updateRootMarginTop(prevState.height, this.state.height)
  }

  componentWillUnmount() {
    // @ts-expect-error TS(2339): Property 'height' does not exist on type 'Readonly... Remove this comment to see the full error message
    this.updateRootMarginTop(this.state.height, 0)
    window.removeEventListener('resize', this.updateHeight)
    clearTimeout(this.timer)
  }

  getRefHeight = () => get('ref.current.offsetHeight', this)

  updateHeight = () => {
    // @ts-expect-error TS(2339): Property 'adjustWrapper' does not exist on type 'R... Remove this comment to see the full error message
    const { adjustWrapper, inner } = this.props
    if (adjustWrapper && !inner) {
      this.setState({ height: this.getRefHeight() })
    }
  }

  updateRootMarginTop = (prevHeight, newHeight) => {
    if (this.rootDOM) {
      const { style } = this.rootDOM
      const currentMarginTop = toNumber(style.marginTop.replace('px', ''))
      style.marginTop = `${currentMarginTop - prevHeight + newHeight}px`
    }
  }

  render() {
    // @ts-expect-error TS(2339): Property 'children' does not exist on type 'Readon... Remove this comment to see the full error message
    const { children, type, fixed } = this.props
    // @ts-expect-error TS(2339): Property 'height' does not exist on type 'Readonly... Remove this comment to see the full error message
    const { height, show } = this.state
    const className = classNames(
      styles.notification,
      get(type, styles),
      { [styles.fixed]: fixed },
      // @ts-expect-error TS(2339): Property 'className' does not exist on type 'Reado... Remove this comment to see the full error message
      this.props.className,
    )

    if (!show) {
      return null
    }

    const symbol = {
      success: 'general-check-circle',
      warn: 'general-info-circle',
      error: 'alerts-alert-circle',
    }

    return (
      // @ts-expect-error TS(2322): Type 'RefObject<unknown>' is not assignable to typ... Remove this comment to see the full error message
      <div className={className} ref={this.ref}>
        <Icon className={styles.icon} symbol={symbol[type]} />
        {children || <FormattedMessage {...this.props} />}
        {height > 0 && <style>{`.fixed-flexible { top: ${height}px; }`}</style>}
      </div>
    )
  }
}
